import React from 'react';
import MentionText from '../../MentionText';
import { splitHighlights, PLAN, EASE } from './planModel';

/**
 * A message's words with the phrases the plan was pulled from underlined (handoff §1): a dotted
 * 2px pink line 4px under the text and a #FFF0F8 fill that wipes in left to right (prPlanMark,
 * staggered per message by `delayMs`). Tapping a highlight opens the plan sheet. Everything else
 * still goes through MentionText, so @handles keep working inside a highlighted run.
 */
export default function HighlightedText({ text, quotes, onOpen, delayMs = 180, animate = true }) {
  const parts = splitHighlights(text, quotes);
  if (!parts.some((p) => p.on)) return <MentionText text={text} />;
  return (
    <>
      {parts.map((p, i) => (p.on ? (
        <span
          key={i}
          data-plan-highlight
          role="button"
          tabIndex={0}
          onClick={(e) => { e.stopPropagation(); onOpen?.(); }}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); onOpen?.(); } }}
          style={{
            borderRadius: 4,
            cursor: 'pointer',
            textDecorationLine: 'underline',
            textDecorationStyle: 'dotted',
            textDecorationColor: PLAN.pink,
            textDecorationThickness: 2,
            textUnderlineOffset: 4,
            backgroundImage: `linear-gradient(${PLAN.pinkFill}, ${PLAN.pinkFill})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100% 100%',
            animation: animate ? `prPlanMark 520ms ${EASE} ${delayMs}ms both` : 'none',
          }}
        >
          <MentionText text={p.t} />
        </span>
      ) : <MentionText key={i} text={p.t} />))}
    </>
  );
}
